module.exports = __webpack_public_path__ + "img/80.295a11d6.jpg";